var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_tab"},[_c('div',{attrs:{"id":"board_tab"}},_vm._l((_vm.categories),function(key,index){return _c('div',{key:index,class:`board01`},[_c('strong',[_vm._v(_vm._s(key.title))]),_c('ul',_vm._l((_vm.listOfCategory[key.lnbid]),function(value,i){return _c('li',{key:i,class:{ new: _vm.boo(value) }},[_c('a',{on:{"click":function($event){return _vm.Read(value, key, {
                lnbid: key.lnbid,
                type: key.type,
                top: _vm.top,
                title: key.title,
              })}}},[(value.category)?_c('strong',[_vm._v("["+_vm._s(value.category)+"]")]):_vm._e(),_vm._v(_vm._s(value.subject))])])}),0),_c('span',{staticClass:"m_more"},[_c('router-link',{attrs:{"to":{
            name: `${key.category}list`,
            query: {
              data: JSON.stringify({
                lnbid: key.lnbid,
                type: key.type,
                top: _vm.top,
                title: key.title,
              }),
            },
          }}})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }